import React, { useEffect, useState } from 'react';

const Footer = () => {
	const [year, setYear] = useState('');

	useEffect(() => {
		setYear(new Date().getFullYear().toString());
	}, []);

	return (
		<footer className="footer">
			<div className="padding-global">
				<div className="container-large">
					<div className="footer_wrapper">
						<div className="footer-bottom_wrapper">
							<div className="footer-logo" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
								<div style={{ 
									fontSize: 'clamp(2.5rem, 8vw, 8.5rem)', 
									fontWeight: 'bold', 
									color: '#FAFAFA',
									textAlign: 'center',
									letterSpacing: '1px',
									lineHeight: '1.2'
								}}>
									SOL Treasury Corp
								</div>
								
								<div style={{ 
									display: 'flex', 
									gap: '4px',
									opacity: '0.8',
									transform: 'translateY(-15px)',
									marginLeft: '80%'
								}}>
									<span style={{ 
										color: '#888', 
										fontSize: '0.9rem',
										fontWeight: 'normal'
									}}>
										by
									</span>
									<img 
										src="/logo-htl.png" 
										alt="Acheter-Louer" 
										style={{
											height: '28px',
											width: 'auto',
											backgroundColor: 'white',
											padding: '2px 4px',
											borderRadius: '2px',
											opacity: '1'
										}}
									/>
								</div>
							</div>
							<div style={{ marginTop: '3rem' }}>
								<div style={{ 
									display: 'grid', 
									gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
									gap: '6rem',
									justifyItems: 'center'
								}}>
									<div className="footer-info_wrapper" style={{ textAlign: 'center' }}>
										<div className="text-size-small">
											<div className="text-color-grey-10">
												<div className="typeface-dm-mono">
													<div className="text-style-allcaps">
														<div>Investor Contact</div>
													</div>
												</div>
											</div>
										</div>
										<div className="text-size-large">
											<div>Sol Treasury Corp<br />2 rue de Tocqueville 75017 Paris France<br />contact@soltreasurycorp.com<br />RCS PARIS 905 288 841<br />Filiale du Groupe ACHETER-LOUER.FR</div>
										</div>
									</div>
								
									<div className="footer-info_wrapper">
										<div className="text-size-small">
											<div className="text-color-grey-10">
												<div className="typeface-dm-mono">
													<div className="text-style-allcaps">
														<div>Follow Us</div>
													</div>
												</div>
											</div>
										</div>
										<div className="footer-links_wrapper">
											<a href="https://x.com/soltreasury?s=11" target="_blank" className="circle-link w-inline-block">
												<div 
													className="link-circle"
													style={{
														opacity: 0,
														transform: "translate3d(-1rem, -50%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
														transformStyle: "preserve-3d"
													}}
												></div>
												<div className="circle-link-text">
													<div className="text-size-large">
														<div>X (Twitter)</div>
													</div>
												</div>
											</a>
										</div>
									</div>
								</div>
							</div>
							<div className="spacer-4 spacer-mobile-2"></div>
							<div style={{
								width: '100%',
								height: '2px',
								backgroundColor: 'rgba(255, 255, 255, 0.2)',
								margin: '2rem 0'
							}}></div>
              {/* Bouton retour en haut */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '2rem 0'
              }}>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    backdropFilter: 'blur(10px)',
                    color: '#FAFAFA'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      d="M12 19V5M5 12L12 5L19 12" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
							<div className="copyright_wrapper">
								<div className="text-size-small">
									<div className="typeface-dm-mono">
										<div className="text-style-allcaps">
											<div>© Copyright <span data-copyright-year="true">{year}</span>. All rights reserved</div>
										</div>
									</div>
								</div>
							
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;